import { render } from "./CIS-Banner.vue?vue&type=template&id=35495e20&scoped=true"
import script from "./CIS-Banner.vue?vue&type=script&lang=js"
export * from "./CIS-Banner.vue?vue&type=script&lang=js"

import "./CIS-Banner.vue?vue&type=style&index=0&id=35495e20&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35495e20"]])

export default __exports__